/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkStartBotRequest,
  BulkStopBotRequest,
  HTTPValidationError,
  StartBotRequest,
} from '../models/index';
import {
    BulkStartBotRequestFromJSON,
    BulkStartBotRequestToJSON,
    BulkStopBotRequestFromJSON,
    BulkStopBotRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    StartBotRequestFromJSON,
    StartBotRequestToJSON,
} from '../models/index';

export interface BulkStartBotsApiBotsBulkStartPostRequest {
    bulkStartBotRequest: BulkStartBotRequest;
    xApiKey?: string | null;
}

export interface BulkStopBotsApiBotsBulkStopPostRequest {
    bulkStopBotRequest: BulkStopBotRequest;
    xApiKey?: string | null;
}

export interface GetBotLogsApiBotsGroupIdLogsGetRequest {
    groupId: number;
    xApiKey?: string | null;
}

export interface GetBotsStatusApiBotsGetRequest {
    xApiKey?: string | null;
}

export interface ReloadGroupsCacheApiBotsReloadGroupsCachePostRequest {
    xApiKey?: string | null;
}

export interface StartBotApiBotsGroupIdStartPostRequest {
    groupId: number;
    startBotRequest: StartBotRequest;
    xApiKey?: string | null;
}

export interface StopBotApiBotsGroupIdStopPostRequest {
    groupId: number;
    xApiKey?: string | null;
}

/**
 * 
 */
export class BotsApi extends runtime.BaseAPI {

    /**
     * Start bots for multiple groups concurrently. All docker compose commands run in parallel via ThreadPoolExecutor.
     * Bulk Start Bots
     */
    async bulkStartBotsApiBotsBulkStartPostRaw(requestParameters: BulkStartBotsApiBotsBulkStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['bulkStartBotRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkStartBotRequest',
                'Required parameter "bulkStartBotRequest" was null or undefined when calling bulkStartBotsApiBotsBulkStartPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/bots/bulk/start`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkStartBotRequestToJSON(requestParameters['bulkStartBotRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Start bots for multiple groups concurrently. All docker compose commands run in parallel via ThreadPoolExecutor.
     * Bulk Start Bots
     */
    async bulkStartBotsApiBotsBulkStartPost(requestParameters: BulkStartBotsApiBotsBulkStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.bulkStartBotsApiBotsBulkStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stop bots for multiple groups concurrently. All docker compose commands run in parallel via ThreadPoolExecutor.
     * Bulk Stop Bots
     */
    async bulkStopBotsApiBotsBulkStopPostRaw(requestParameters: BulkStopBotsApiBotsBulkStopPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['bulkStopBotRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkStopBotRequest',
                'Required parameter "bulkStopBotRequest" was null or undefined when calling bulkStopBotsApiBotsBulkStopPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/bots/bulk/stop`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkStopBotRequestToJSON(requestParameters['bulkStopBotRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Stop bots for multiple groups concurrently. All docker compose commands run in parallel via ThreadPoolExecutor.
     * Bulk Stop Bots
     */
    async bulkStopBotsApiBotsBulkStopPost(requestParameters: BulkStopBotsApiBotsBulkStopPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.bulkStopBotsApiBotsBulkStopPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get logs for a specific group\'s bot.  Args:     group_id: The group ID to get logs for  Returns:     Dict with logs content and metadata
     * Get Bot Logs
     */
    async getBotLogsApiBotsGroupIdLogsGetRaw(requestParameters: GetBotLogsApiBotsGroupIdLogsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getBotLogsApiBotsGroupIdLogsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/bots/{group_id}/logs`;
        urlPath = urlPath.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get logs for a specific group\'s bot.  Args:     group_id: The group ID to get logs for  Returns:     Dict with logs content and metadata
     * Get Bot Logs
     */
    async getBotLogsApiBotsGroupIdLogsGet(requestParameters: GetBotLogsApiBotsGroupIdLogsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBotLogsApiBotsGroupIdLogsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the status of all bot containers.  Returns:     Dict containing status information for all bot group IDs including:     - Individual bot status for each group     - Summary statistics (total, running, stopped)
     * Get Bots Status
     */
    async getBotsStatusApiBotsGetRaw(requestParameters: GetBotsStatusApiBotsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/bots`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get the status of all bot containers.  Returns:     Dict containing status information for all bot group IDs including:     - Individual bot status for each group     - Summary statistics (total, running, stopped)
     * Get Bots Status
     */
    async getBotsStatusApiBotsGet(requestParameters: GetBotsStatusApiBotsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBotsStatusApiBotsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reload the groups cache.
     * Reload Groups Cache
     */
    async reloadGroupsCacheApiBotsReloadGroupsCachePostRaw(requestParameters: ReloadGroupsCacheApiBotsReloadGroupsCachePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/bots/reload_groups_cache`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Reload the groups cache.
     * Reload Groups Cache
     */
    async reloadGroupsCacheApiBotsReloadGroupsCachePost(requestParameters: ReloadGroupsCacheApiBotsReloadGroupsCachePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.reloadGroupsCacheApiBotsReloadGroupsCachePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start bots for a specific group with the specified number of users.  Args:     group_id: The group ID to start bots for     request: Request body containing users_count  Returns:     Dict with status and message about the operation
     * Start Bot
     */
    async startBotApiBotsGroupIdStartPostRaw(requestParameters: StartBotApiBotsGroupIdStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling startBotApiBotsGroupIdStartPost().'
            );
        }

        if (requestParameters['startBotRequest'] == null) {
            throw new runtime.RequiredError(
                'startBotRequest',
                'Required parameter "startBotRequest" was null or undefined when calling startBotApiBotsGroupIdStartPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/bots/{group_id}/start`;
        urlPath = urlPath.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartBotRequestToJSON(requestParameters['startBotRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Start bots for a specific group with the specified number of users.  Args:     group_id: The group ID to start bots for     request: Request body containing users_count  Returns:     Dict with status and message about the operation
     * Start Bot
     */
    async startBotApiBotsGroupIdStartPost(requestParameters: StartBotApiBotsGroupIdStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.startBotApiBotsGroupIdStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stop bots for a specific group.  Args:     group_id: The group ID to stop bots for  Returns:     Dict with status and message about the operation
     * Stop Bot
     */
    async stopBotApiBotsGroupIdStopPostRaw(requestParameters: StopBotApiBotsGroupIdStopPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling stopBotApiBotsGroupIdStopPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/bots/{group_id}/stop`;
        urlPath = urlPath.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Stop bots for a specific group.  Args:     group_id: The group ID to stop bots for  Returns:     Dict with status and message about the operation
     * Stop Bot
     */
    async stopBotApiBotsGroupIdStopPost(requestParameters: StopBotApiBotsGroupIdStopPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.stopBotApiBotsGroupIdStopPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
